// Shared tokens for the unified Machines module (printers + equipment
// browsed, tagged, and managed from one place).
export const TEAL = '#5DD0C8';

export const STATUS_LABEL = {
  active: 'Active', semi_active: 'Semi-active', inactive: 'Inactive', decommissioned: 'Decommissioned',
};

export const STATUS_PILL = {
  active:         'bg-status-ok/[0.12] border-status-ok/[0.3] text-status-ok',
  semi_active:    'bg-ink-yellow/[0.12] border-ink-yellow/[0.3] text-ink-yellow',
  inactive:       'border-border-strong text-text-tertiary',
  decommissioned: 'border-border-strong text-text-tertiary',
};

/** Merge printers + equipment rows into one shape for the unified list. */
export const buildMachineList = (printers, equipment) => {
  const p = (printers ?? []).map((row) => ({
    id: row.id, type: 'printer', name: row.name, model: row.model, status: row.status,
    categoryId: row.categoryId, categoryName: row.categoryName, categoryColor: row.categoryColor,
    location: row.location, ipAddress: row.ipAddress,
    href: `/printers/${row.id}`, raw: row,
  }));
  const e = (equipment ?? []).map((row) => ({
    id: row.id, type: 'equipment', name: row.name, model: row.model, status: row.status,
    categoryId: row.categoryId, categoryName: row.categoryName, categoryColor: row.categoryColor,
    location: row.location, ipAddress: row.ipAddress,
    href: null, raw: row,
  }));
  return [...p, ...e].sort((a, b) => a.name.localeCompare(b.name));
};
